import { useState, useEffect, useCallback } from 'react';
import { fetchWeeklyAuctions, fetchTenantStats, fetchSummary } from '../utils/api';

/**
 * Custom hook that fetches all dashboard data.
 * @param {string} [selectedMonth] - Month in YYYY-MM format.
 * @param {number} [dbIndex] - 1-based database index.
 */
export function useDashboard(selectedMonth, dbIndex) {
  const [weeklyAuctions, setWeeklyAuctions] = useState([]);
  const [tenantStats, setTenantStats] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [auctions, stats, sum] = await Promise.all([
        fetchWeeklyAuctions(dbIndex),
        fetchTenantStats(selectedMonth, dbIndex),
        fetchSummary(selectedMonth, dbIndex),
      ]);
      setWeeklyAuctions(auctions);
      setTenantStats(stats);
      setSummary(sum);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [selectedMonth, dbIndex]);

  useEffect(() => {
    load();
  }, [load]);

  return { weeklyAuctions, tenantStats, summary, loading, error, refetch: load };
}
